import { Config } from '../config/config.es6';
import { Howl } from 'howler';

// import assets from './_manifest.es6';

export default class Sound {
    constructor() {
        this.assets = Config.SOUND_ASSETS;
        this.sounds = {};
        this.loaded = 0;
        this.total = Object.keys(this.assets).length; // ロードする全アセットの数
        this.isInit = false;

        // 一時停止から復帰した際に再生させる音を保存
        this.playingSounds = new Set();
    }

    /**
     * アセットのロード
     * @param callback {function} アセット読み込み完了時のコールバック
     */
    load(callback) {
        this.callback = callback;
        this._createSE();
    }

    /**
     * 再生する
     * @param id {string} manifest記載のid
     */
    playAudio(id) {
        if(!this.sounds[id]) return;
        if(this.sounds[id].playing()) return;
        this.sounds[id].play();
    }

    /**
     * 停止する
     * @param id {string} manifest記載のid
     */
    stopAudio(id) {
        if (!this.sounds[id]) return;
        this.sounds[id].stop();
    }

    stopAll() {
        Object.keys(this.sounds).forEach((key) => {
            this.sounds[key].stop();
        });
    }

    pauseAll() {
        this._logPlayingSounds('pauseAll start');

        Object.keys(this.sounds).forEach((key) => {
            if (this.sounds[key].playing()) {
                this.playingSounds.add(key);
                this.sounds[key].pause();
            }
        });

        this._logPlayingSounds('pauseAll end');
    }

    resumeAll() {
        this._logPlayingSounds('resumeAll start');

        this.playingSounds.forEach((key) => {
            
            if(this.sounds[key] && !this.sounds[key].playing()){
                this.sounds[key].play();
            }
        });
        
        this.playingSounds.clear();

        this._logPlayingSounds('resumeAll end');
    }

    _createSE() {
        Object.keys(this.assets).forEach((key) => {
            this.sounds[key] = new Howl(this.assets[key]);
            this.sounds[key].once('load', () => {
                if (++this.loaded >= Object.keys(this.assets).length) this.callback();
            });
        });

        this.isInit = true;
    }

    getLoadProgress() {
        console.log(this.loaded / this.total);
        return this.loaded / this.total;
    }


    _logPlayingSounds(label) {
        //console.log(`[DEBUG ${label}] playingSounds:`, [...this.playingSounds]);
    }
}
